import React from "react";
import PropTypes from "prop-types";
import { Message } from "../Message.jsx";

export const UserMessage = ({ messageText, ...props }) => {
  return <Message {...props}>{messageText}</Message>;
};

UserMessage.propTypes = {
  messageText: PropTypes.string,
};
